import React from 'react'
import { useAppSelector } from '../../../../redux/hook'
import {
    Applications,
    DEVICE_MANAGER_TABS,
    TAB_PAGE_VIEW,
    URLSearchParamsKeys,
} from '../../../../constants/constants'
import { useSearchParams } from 'react-router-dom'
import Entity from '../../../Entity/EntityList'
import ViewEntity from '../../../ViewEntity'

const DeviceManagerListView: React.FC = () => {
    const deviceManagerSettings = useAppSelector(
        (state) => state.deviceManager.deviceManagerSettings,
    )

    const [searchParams] = useSearchParams()
    const tabPageView =
        searchParams.get(URLSearchParamsKeys.pageView) ||
        TAB_PAGE_VIEW.LIST_VIEW

    const isListView = TAB_PAGE_VIEW.LIST_VIEW === tabPageView

    return isListView ? (
        <Entity
            tabIndex={DEVICE_MANAGER_TABS.LIST_VIEW}
            applicationId={Applications.deviceManager.id}
            templateId={deviceManagerSettings?.deviceTemplateId}
            listQueryParams={{ fetchAll: true }}
        />
    ) : (
        <ViewEntity />
    )
}

export default DeviceManagerListView
